<div [ngClass]="containerClass">
    @if (showProductInfo) {
        <button
            pButton
            type="button"
            class="p-button-info p-button-rounded"
            icon="pi pi-info-circle"
            (click)="productInfoRequested.emit()"
        ></button>
    }

    @if (isEditable) {
        <button
            pButton
            type="button"
            class="p-button-danger p-button-rounded"
            icon="pi pi-trash"
            (click)="deleteRequested.emit()"
            [disabled]="disabledDelete || !canDeleteRow"
        ></button>
    }
</div>
